import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Reviews } from "@/components/Reviews";
import { Contacts } from "@/components/Contacts";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const EMPTY_FILTERS = { category: "Tutti", brand: "", fuel: "", maxPrice: "", q: "" };

export default function Home() {
  const lenisRef = useRef(null);
  const [filters, setFilters] = useState(EMPTY_FILTERS);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(id, { offset: -70 });
    } else {
      document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const handleHeroSearch = useCallback(
    (f) => {
      setFilters({ ...EMPTY_FILTERS, ...f });
      scrollTo("#catalogo");
    },
    [scrollTo]
  );

  return (
    <div className="bg-[#0A0D14] text-gray-100 min-h-screen" data-testid="home-page">
      <div className="noise-overlay" />
      <Navbar onNavigate={scrollTo} />
      <Hero onSearch={handleHeroSearch} onExplore={scrollTo} />
      <Marquee />
      <Catalog filters={filters} setFilters={setFilters} />
      <Services />
      <Manifesto />
      <Reviews />
      <Contacts />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
